import { Injectable } from '@angular/core';
import { Platform } from "ionic-angular";
import { Flashlight } from '@ionic-native/flashlight';

@Injectable()

export class FlashlightService {

  private isOn = false;
  private isReady = false;

  constructor(
    public platform: Platform,
    private flashlight: Flashlight
  ) {
    this.platform.ready().then(() => {
      if(this.platform.is('cordova') && this.flashlight.available()) {
        this.isReady = true;
      }
    })
  }

  public toggle(){
    this.isOn = !this.isOn;
    if(this.isReady){
      this.flashlight.toggle();
    }
  }

  public switchOn() {
    this.isOn = true;
    if(this.isReady){
      this.flashlight.switchOn();
    }
  }

  public switchOff() {
    this.isOn = false;
    if(this.isReady){
      this.flashlight.switchOff();
    }
  }

  public isSwitchedOn() {
    if(this.isReady){
      return this.flashlight.isSwitchedOn();
    }
    return this.isOn;
  }

}



// WEBPACK FOOTER //
// ./src/services/flashlight.service.ts